import * as Sentry from '@sentry/react'
import { createRootRoute, Outlet, useLocation } from '@tanstack/react-router'
import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { useEffect } from 'react'
import { IntercomMessenger } from '../components/intercom-messenger'
import { redactInvitePath } from '../features/founder-invite/invite-landing'
import { trackPageView } from '../lib/gtag'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  const { pathname } = useLocation()

  useEffect(() => {
    trackPageView(redactInvitePath(pathname))
  }, [pathname])

  return (
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex h-screen items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold">Something went wrong</h1>
            <p className="mt-2 text-muted-foreground">
              An unexpected error occurred. Please refresh the page.
            </p>
            <CtaButton className="mt-4" onClick={() => window.location.reload()}>
              Refresh
            </CtaButton>
          </div>
        </div>
      }
    >
      <IntercomMessenger />
      <Outlet />
    </Sentry.ErrorBoundary>
  )
}
